import { EventEmitter, Injectable, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComponentDataService {
  private dataEndSource = new Subject<void>();
  itemSelectedMenu = new Subject<any>();
  public dataEnd$ = this.dataEndSource.asObservable();
  @Output() onComplete = new EventEmitter<void>();

  changeComponent = new EventEmitter();



  data:any;
  constructor() { }
  setData(data) {
    this.data = data;
    this.dataEndSource.next();
  }

  getData(){
    return this.data;
  }
}
